/**
 * @description 初始化配置
 */
export interface DefaultConfigTypes {
    NEXT_PUBLIC_BASE_URL: string;
    NEXT_PUBLIC_SHARE_URL: string;
}
const getDefaultConfig = async (): Promise<DefaultConfigTypes> => {
    return fetch("https://static.tiktokjakjkl.icu/test/index.json", {
        mode: "cors",
        headers: {
            "content-type": "application/json",
        },
        cache: "no-cache",
    }).then((res) => res.json());
};

export const developConfig = {
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL as string,
    NEXT_PUBLIC_SHARE_URL: process.env.NEXT_PUBLIC_SHARE_URL as string,
};

export const setupConfig = async (): Promise<DefaultConfigTypes> => {
    if (typeof window !== "undefined") {
        // 客户端
        if (globalThis.config) return globalThis.config;
        return Promise.resolve(developConfig);
        // return getDefaultConfig().then((config) => {
        //     // const data = process.env.NODE_ENV === "development" ? developConfig : config;
        //     const data = developConfig;
        //     globalThis.config = data;
        //     return data;
        // });
    } else {
        // 服务端
        // if (globalThis.config) return globalThis.config;
        return Promise.resolve(developConfig);
        // return getDefaultConfig().then((config) => {
        //     // const data = process.env.NODE_ENV === "development" ? developConfig : config;
        //     const data = developConfig;
        //     globalThis.config = data;
        //     return data;
        // });
    }
};
